const checkIfDTrumInjected = () => {
  return !!window.dtrum;
};

export const identifyUser = (email: string) => {
  if (checkIfDTrumInjected()) {
    window?.dtrum?.identifyUser(email);
  }
};

export const startXhrAction = (url: string | undefined): number | undefined => {
  if (checkIfDTrumInjected()) {
    const actionId = window?.dtrum?.enterXhrAction('', undefined, url);
    return actionId;
  }
  return undefined;
};

export const endXhrAction = (actionId: number) => {
  if (checkIfDTrumInjected()) {
    window?.dtrum?.leaveXhrAction(actionId, Date.now());
  }
};
